import React, {useContext} from 'react'
import {rgmContext} from '../gatsby-theme-carbon/components/Layout';

function ProgressBar() {
    const rgm = useContext(rgmContext);
    return (
        <div id="progress-wrapper" className="padd">
            {rgm?.answers?.completed_count !== rgm?.tasks.length && <p>{`You have ${rgm?.answers?.completed_count ? rgm?.answers?.completed_count : 0} of ${rgm?.tasks.length} tasks completed`}</p>}
            {rgm?.answers?.completed_count === rgm?.tasks.length && <p>{`You have completed all tasks`}</p>}
            <progress id="progress" value={rgm?.answers?.percentage} max="100" color="#89b3d2"></progress>
        </div>
    )
}

export default ProgressBar
